import { useState, useEffect, useCallback } from 'react'

import useApiGet from '../../Shared/Hooks/useApiGet'
import useSentry from '../../Shared/Hooks/useSentry'

const SORTABLE_COLUMN_TO_API_KEY = {
  publishingDate: 'publishing_date',
}

function useEligibleModels() {
  const [eligibleModels, setEligibleModels] = useState([])
  const [hasFetched, setHasFetched] = useState(false)
  const [paginationMeta, setPaginationMeta] = useState({
    totalCount: 0,
    totalPages: 0,
    currentPage: 1,
    perPage: 40,
  })
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 40,
    sortKey: null,
    sortDirection: null,
  })
  const { getData, isLoading, error } = useApiGet({ initialLoading: true })
  const { captureException } = useSentry()

  const fetchEligibleModels = useCallback(() => {
    const sortByParam = filters.sortKey ? SORTABLE_COLUMN_TO_API_KEY[filters.sortKey] : null

    getData({
      path: '/api/internal/subscription-eligible-items',
      params: {
        page: filters.page,
        per_page: filters.perPage,
        ...(sortByParam && { sort_by: sortByParam }),
        ...(sortByParam && filters.sortDirection && { sort_direction: filters.sortDirection }),
      },
      onSuccess: (response) => {
        const transformedModels = response.data.data.map((item) => ({
          id: parseInt(item.id, 10),
          name: item.attributes.name,
          smallImage: item.attributes.smallImage,
          publishingDate: item.attributes.publishingDate,
          subscriptionOptInDate: item.attributes.subscriptionOptInDate,
        }))

        setEligibleModels(transformedModels)
        setHasFetched(true)

        setPaginationMeta({
          totalCount: parseInt(response.data.meta.totalCount, 10),
          totalPages: parseInt(response.data.meta.totalPages, 10),
          currentPage: parseInt(response.data.meta.currentPage, 10),
          perPage: parseInt(response.data.meta.perPage, 10),
        })
      },
      onError: (err) => {
        setHasFetched(true)
        captureException(err)
      },
    })
  }, [getData, captureException, filters])

  useEffect(() => {
    fetchEligibleModels()
  }, [fetchEligibleModels])

  return {
    eligibleModels,
    isLoading,
    error,
    refetch: fetchEligibleModels,
    paginationMeta,
    filters,
    setFilters,
    hasFetched,
  }
}

export default useEligibleModels
